import { Component, Input } from '@angular/core';

import { TooltipContent, TooltipService } from '../../services/tooltip.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'tooltip-badge',
  template: `
    <div [fxLayout]="cService.isPcViewport ? 'row' : 'column'">
      <div
        class="icon-customization"
        vrm-button
        fxLayout="row"
        fxLayoutAlign="center center"
        (mouseenter)="displayTooltip($event)"
        (mouseleave)="hideTooltip()"
      >
        <span>i</span>
      </div>
    </div>
  `,
  styles: [
    `
      .icon-customization {
        font-size: 18px;
        color: white;
        text-align: center;
        margin: 0 10px 0 15px;
        margin-top: 10px;
        width: 25px;
        height: 25px;
        border-radius: 100%;
        font-weight: bold;
        border: 2px solid #ccc;
        cursor: pointer;
      }
    `,
  ],
})
export class TooltipBadgeComponent {
  tooltipHidden: boolean = true;

  @Input() tooltipTitle: string = '';
  @Input() tooltipMessage: string;

  constructor(public cService: CommonService, private tTipService: TooltipService) {}

  displayTooltip(event: { target: any }) {
    const tooltipContent: TooltipContent = {
      title: this.tooltipTitle,
      description: this.tooltipMessage,
      richToolTip: {
        topOffset: this.cService.isMobileViewport ? '' : '-2.5em',
        leftOffset: this.cService.isMobileViewport ? '' : '9em',
        maxWidth: '80%',
      },
    };

    if (tooltipContent) {
      this.tTipService.setContent(tooltipContent);
      this.tTipService.displayRelativeTo(event.target);
    }
  }

  hideTooltip() {
    this.tTipService.hide();
  }
}
